import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './services/AuthContext';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const db = getFirestore(); // Initialize Firestore once

const ProtectedRoute = ({ element, requiredRoles = [] }) => {
    const { user } = useAuth();
    const [userRole, setUserRole] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const fetchUserRole = async () => {
            if (!user) {
                setLoading(false);
                return;
            }

            try {
                const userDoc = await getDoc(doc(db, 'users', user.uid));
                if (isMounted) {
                    setUserRole(userDoc.exists() ? userDoc.data().role?.toLowerCase() : null);
                    setLoading(false);
                }
            } catch (error) {
                if (isMounted) {
                    console.error('Error fetching user role:', error);
                    setLoading(false);
                }
            }
        };

        fetchUserRole();

        return () => { isMounted = false; }; // Cleanup function
    }, [user]);

    if (loading) return React.createElement('div', null, 'Loading...');
    if (!user) return React.createElement(Navigate, { to: "/signin", replace: true });
    if (!userRole) return React.createElement('div', null, 'Fetching role...');

    // Normalize requiredRoles to lowercase for consistency
    const normalizedRoles = requiredRoles.map(role => role.toLowerCase());

    return (normalizedRoles.length === 0 || normalizedRoles.includes(userRole))
        ? element
        : React.createElement(Navigate, { to: "/not-authorized", replace: true });
};

export default ProtectedRoute;
